export const registerPhoneMask = (value: string | undefined): string => {
	if (!value) return '';
	return value
		.replace(/\D/g, '')
		.replace(/^(\d{2})(\d)/g, '($1) $2')
		.replace(/(\d{1})(\d{4})(\d{4})$/, '$1 $2-$3');
};
